var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNoodles = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 36.6667C12.6367 36.6667 5 32.3634 5 25C5 23.1584 6.49167 21.6667 8.33333 21.6667H31.6667C33.5083 21.6667 35 23.1584 35 25C35 32.3634 27.3633 36.6667 20 36.6667Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 5.83331C12.4134 5.83331 11.6667 6.57998 11.6667 7.49998V22.5C11.6667 23.42 12.4134 24.1666 13.3334 24.1666C14.2534 24.1666 15.0001 23.42 15.0001 22.5V7.49998C15.0001 6.57998 14.2534 5.83331 13.3334 5.83331Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 5C17.4134 5 16.6667 5.74667 16.6667 6.66667V16.6667C16.6667 17.5867 17.4134 18.3333 18.3334 18.3333C19.2534 18.3333 20.0001 17.5867 20.0001 16.6667V6.66667C20.0001 5.74667 19.2534 5 18.3334 5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 5C22.4134 5 21.6667 5.74667 21.6667 6.66667V16.6667C21.6667 17.5867 22.4134 18.3333 23.3334 18.3333C24.2534 18.3333 25.0001 17.5867 25.0001 16.6667V6.66667C25.0001 5.74667 24.2534 5 23.3334 5Z",
    fill: "currentColor"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 16.6666H6.66667C5.74667 16.6666 5 15.92 5 15C5 14.08 5.74667 13.3333 6.66667 13.3333H11.6667V16.6666Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 13.3333H35C35.92 13.3333 36.6667 14.08 36.6667 15C36.6667 15.92 35.92 16.6666 35 16.6666H25V13.3333Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47174 8.345C5.55674 8.45167 4.90341 9.28167 5.01174 10.195C5.11174 11.0417 5.83174 11.6667 6.66508 11.6667C6.73008 11.6667 6.79674 11.6633 6.86174 11.655L11.6667 11.09V7.73334L6.47174 8.345Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9683 7.34502C14.9733 7.39835 14.9999 7.44502 14.9999 7.50002V10.6984L16.6666 10.5017V7.14502L14.9683 7.34502Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.69 6.55499L20 6.75333V10.11L21.6667 9.91333V6.66666C21.6667 6.62666 21.6867 6.59333 21.69 6.55499Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8049 5.01165L24.8999 6.17665C24.9499 6.33498 24.9999 6.49332 24.9999 6.66665V9.52165L35.1949 8.32165C36.1099 8.21498 36.7632 7.38498 36.6549 6.47165C36.5466 5.55832 35.7066 4.89665 34.8049 5.01165Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoodles, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/noodles.b7de98a5.svg";
export { ForwardRef as ReactComponent };